import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-brand-bg py-16" data-id="element-25">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-27">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-text mb-4 font-heading leading-tight" data-id="element-28">
            El negocio que quieres empieza con la vela que haces esta semana.
          </h2>

          <div className="mt-8 mb-4" data-id="element-29">
            <CTAButton className="w-full sm:w-auto text-xl px-12 py-5" data-id="element-30">
              COMPRAR AHORA —{' '}
              <span className="line-through opacity-60 mr-1" data-id="element-31">$27</span> $17
            </CTAButton>
          </div>

          <p className="text-lg text-brand-subtext font-medium mb-6 mt-8" data-id="element-32">
            Acceso inmediato. Sin contratos. Sin sorpresas.
          </p>

          <div className="inline-flex items-center justify-center gap-2 bg-brand-alt px-6 py-3 rounded-full border border-brand-line/30" data-id="element-33">
            <span className="text-sm text-brand-subtext" data-id="element-34">
              📥 Producto 100% Digital — PDF Imprimible — No incluye materiales
              físicos
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}